import { Avatar, Box, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useMediaContext } from "context/MediaContext"
import { DeckType } from "model/DeckType"
import { Statistics, Statistic } from "model/Statistics"
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"

import quizimg from '../../asset/quiz.png'

type State = {
  is_subscriber: boolean
  statistics: Statistics
  target: Statistic
}
export default function AnalyticsDetail() {
  const { isPc } = useMediaContext()
  const navigate = useNavigate()
  const location = useLocation()
  const { is_subscriber, statistics, target } = location.state as State

  const [statistic, setStatistic] = useState<Statistic | null>(null)
  useEffect(() => {
    if (!statistics || !target) {
      navigate('/')
    } else {
      const source = target.records_by_opponent.slice()

      target.records_by_opponent = target.records_by_opponent
        .filter(it => it.opponent_deck_type.main_theme.name !== 'その他')
      target.records_by_opponent.sort((a, b) => b.win_rate - a.win_rate)

      const other = source.find(it => it.opponent_deck_type.main_theme.name === 'その他')
      if (other) {
        target.records_by_opponent.push(other)
      }

      setStatistic(target)
    }
  }, [target])

  function getDeckTypeName(deckType: DeckType): string {
    if (!is_subscriber) return '???'
    if (!deckType) return ''
    const mainThemeName = deckType.main_theme.name
    const subThemeName = deckType.sub_theme?.name
    let name = mainThemeName
    if (subThemeName) name += ` + ${subThemeName}`
    return name
  }

  function fixRate(rate: number) {
    if (isNaN(Number(rate))) return isPc ? 'データなし' : 'NoData'
    return `${rate}%`
  }

  if (!statistics || !target || !statistic) {
    return (
      <></>
    )
  }
  return (
    <>
      <Box
        display='flex'
        flexDirection='row'
        sx={{
          bgcolor: 'background.default',
          mb: 3
        }}
      >
        <Avatar
          src={is_subscriber ? statistic!.deck_type.thumbnail_url : quizimg}
          sx={{height: 75, width: 75}}
        />
        <Box display='flex' flexDirection='column' sx={{ml: 2}}>
          <Typography sx={{mt: 0.5}}>{getDeckTypeName(statistic!.deck_type)}</Typography>
          <Box sx={{display: 'flex', flexDirection: 'row', mt: 0.5}}>
            <Box 
              sx={{display: 'flex', flexDirection: 'column'}} 
              textAlign='center' 
            >
              <Typography variant='body2' color='text.secondary'>勝率</Typography>
              <Typography variant='body2'>{fixRate(statistic!.win_rate)}</Typography>
            </Box>
            <Box 
              sx={{ml: 3, display: 'flex', flexDirection: 'column'}} 
              textAlign='center' 
            >
              <Typography variant='body2' color='text.secondary'>先攻勝率</Typography>
              <Typography variant='body2'>{fixRate(statistic!.first_win_rate)}</Typography>
            </Box>
            <Box 
              sx={{ml: 3, display: 'flex', flexDirection: 'column'}} 
              textAlign='center' 
            >
              <Typography variant='body2' color='text.secondary'>後攻勝率</Typography>
              <Typography variant='body2'>{fixRate(statistic!.second_win_rate)}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <TableContainer sx={{bgcolor: 'background.default'}}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>VS</TableCell>
              <TableCell>勝率</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {statistic!.records_by_opponent.map(it => (
              <React.Fragment key={it.opponent_deck_type.id}>
                <TableRow>
                  <TableCell rowSpan={3}>
                    <Box display='flex' flexDirection='row' alignItems='center'>
                      <Avatar
                        src={is_subscriber ? it.opponent_deck_type.thumbnail_url : quizimg}
                        variant='rounded'
                        sx={{mr: 0.5}}
                      />
                      <Link
                        sx={{ textDecoration: 'none', cursor: 'pointer' }}
                        onClick={() => navigate('/analyticsdetail', {
                          state: {
                            is_subscriber: is_subscriber,
                            statistics: statistics,
                            target: statistics.statistics.find(_it => _it.deck_type.id === it.opponent_deck_type.id)
                          }
                        })}
                      >
                        {getDeckTypeName(it.opponent_deck_type)}
                      </Link>
                    </Box>
                  </TableCell>
                  <TableCell>{isPc ? 'マッチ' : 'マッチ'}</TableCell>
                  <TableCell>{fixRate(it.win_rate)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{isPc ? '先攻' : '先攻'}</TableCell>
                  <TableCell>{fixRate(it.first_win_rate)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>{isPc ? '後攻' : '後攻'}</TableCell>
                  <TableCell>{fixRate(it.second_win_rate)}</TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}